<ion-header class="ion-no-border">
    <ion-toolbar>
        <ion-title i18n=":@@modal_compare_files.title">Comparar comprovativos</ion-title>

        <ion-buttons slot="end">

            <ion-button fill="clear" color="dark" (click)="ToggleFullscreen()"
                [title]="IsFullscreen ? 'Sair de ecrã inteiro' : 'Ecrã inteiro'">
                <ion-icon slot="icon-only" [name]="IsFullscreen ? 'contract-outline' : 'expand-outline'"></ion-icon>
            </ion-button>

            <ion-button fill="clear" color="dark" (click)="Close()">
                <ion-icon slot="icon-only" name="close-outline"></ion-icon>
            </ion-button>

        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content class="ion-no-padding">
    <app-compare-viewer [files]="Files"></app-compare-viewer>
</ion-content>
